
const report = {
  state: {
    browsePathList: [],
    richTextScrollList: [],
  },
  getters: {
    browsePathList: state => state.browsePathList,
    richTextScrollList: state => state.richTextScrollList,
  },
  mutations: {
    SET_BROWSE_PATH_LIST: (state, data) => {
      state.browsePathList = data;
    },
    SET_RICH_TEXT_SCROLL_LIST: (state, data) => {
      state.richTextScrollList = data;
    },
  },
  actions: {
    toggleBrowsePathList({ commit }, payload) {
      commit('SET_BROWSE_PATH_LIST', payload);
    },
    toggleRichTextScrollList({ commit }, payload) {
      commit('SET_RICH_TEXT_SCROLL_LIST', payload);
    },
  },
};

export default report;
